// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  assignmentId: __t.u64().primaryKey().name("assignment_id"),
  currentStepId: __t.option(__t.string()).name("current_step_id"),
  currentPosition: __t.u32().name("current_position"),
  enteredCurrentStepAt: __t.option(__t.timestamp()).name("entered_current_step_at"),
  sessionId: __t.u64().name("session_id"),
  updatedAt: __t.timestamp().name("updated_at"),
  currentBeat: __t.u32().name("current_beat"),
  totalBeats: __t.u32().name("total_beats"),
  pendingChecks: __t.u32().name("pending_checks"),
  atNextStop: __t.bool().name("at_next_stop"),
  ready: __t.bool(),
});
